import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';

import { Input, Select, Text } from 'v3/components';
import Card, { DefaultLoadingBodyComponent } from 'v3/components/Card';

import { fetchOwners, fetchAnttTypes } from 'utils/fetches';

export default function AnttData({ setData, data, errors }) {
  const [anttTypes, setAnttTypes] = useState([]);

  useEffect(() => {
    fetchAnttTypes().then(setAnttTypes);
  }, []);

  return (

    <Card
      LoadingBodyComponent={() => (
        <DefaultLoadingBodyComponent linesCount={1} perLine={1} />
      )}
      header={
        <Text color="#464E5F" type="header">
          ANTT
        </Text>
      }
    >
      <Row className="form">
        <Col xl={6} lg={6} md={12} xs={12}>
          <Select
            label="Tipo de RNTRC *"
            options={anttTypes}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            value={data?.anttType}
            onChange={value => setData({ ...data, anttType: value })}
            error={errors?.anttType}
          />
        </Col>

        <Col xl={6} lg={6} md={12} xs={12}>
          <Input
            label="RNTRC *"
            type="number"
            value={data?.antt}
            onChange={event => setData({ ...data, antt: event.target.value })}
            error={errors?.antt}
          />
        </Col>
        <Col xl={6} lg={6} md={12} xs={12}>
          <Input
            label="Data de emissão RNTRC *"
            type="date"
            value={data?.anttAdherence}
            onChange={event =>
              setData({ ...data, anttAdherence: event.target.value })
            }
            error={errors?.anttAdherence}
          />
        </Col>
        <Col xl={6} lg={6} md={12} xs={12}>
          <Select.Async
            label={'Proprietário RNTRC *'}
            onSearch={fetchOwners}
            onChange={value => setData({ ...data, anttOwner: value })}
            value={data?.anttOwner}
            getOptionLabel={option => option.label}
            getOptionValue={option => option.id}
            error={errors?.anttOwner}
          />
        </Col>
      </Row>
    </Card>
  );
}

